import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { CommissionsRequestModel } from '../../helpers/objects/request/commissions/commissions-request-model';
import { CommissionsResponseModel } from '../../helpers/objects/response/commissions/commissions-response-model';
import { CommissionReceiptsRequestModel } from '../../helpers/objects/request/commission-receipts/commission-receipts-request-model';
import { CommissionReceiptsResponseModel } from '../../helpers/objects/response/commission-receipts/commission-receipts-response-model';
import { Router, UrlSerializer } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReceiptDetailModel } from '../../helpers/objects/dto/receipt-detail/receipt-detail-model';

@Injectable({
  providedIn: 'root'
})
export class CommissionsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel,
    private serializer: UrlSerializer,
    private translateService: TranslateService,
    private router: Router
  ) {
    this.appConfig = appConfigTemp;
  }

  get(filter: CommissionsRequestModel): Observable<CommissionsResponseModel> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });

    return this.http
      .get<any>(this.appConfig.api + 'comissions/' + this.appConfig.apiPartnershipId, {
        params: httpParams
      })
      .pipe(map((response) => response.body as CommissionsResponseModel));
  }

  getCommissionReceipts(commissionId: number, filter: CommissionReceiptsRequestModel): Observable<CommissionReceiptsResponseModel> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });
    return this.http
      .get<any>(this.appConfig.api + 'comissions/' + this.appConfig.apiPartnershipId + '/' + commissionId + '/receipts', {
        params: httpParams
      })
      .pipe(map((response) => response.body as CommissionReceiptsResponseModel));
  }

  getCommissionReceipt(commissionId: number, receiptId: number): Observable<ReceiptDetailModel> {
    return this.http
      .get<any>(this.appConfig.api + 'comissions/' + this.appConfig.apiPartnershipId + '/' + commissionId + '/receipts/' + receiptId)
      .pipe(map((response) => response.body.comissionReceipt as ReceiptDetailModel));
  }

  download(filter: CommissionsRequestModel): string {
    const extraParams = {
      pageSize: 10000,
      page: 1,
      Authorization: sessionStorage.getItem('token'),
      location: this.translateService.currentLang
    };
    const params = { ...filter, ...extraParams };
    const query = this.router.createUrlTree([], { queryParams: params });
    return this.appConfig.api + 'comissions-worksheet/' + this.appConfig.apiPartnershipId + '?' + (this.serializer.serialize(query).split('?')[1] || '');
  }

  downloadReceipts(filter: CommissionReceiptsRequestModel, comissiondId: any): string {
    const extraParams = {
      pageSize: 10000,
      page: 1,
      Authorization: sessionStorage.getItem('token'),
      location: this.translateService.currentLang
    };
    const params = { ...filter, ...extraParams };
    const query = this.router.createUrlTree([], { queryParams: params });
    return (
      this.appConfig.api +
      'comissions/' +
      this.appConfig.apiPartnershipId +
      '/' +
      comissiondId +
      '/receipts-worksheet' +
      '?' +
      (this.serializer.serialize(query).split('?')[1] || '')
    );
  }
}
